import ResizeObserver from 'resize-observer-polyfill'

export default {
  data () {
    return {
      width: null,
      height: null,

      observer: null,
    }
  },

  mounted () {
    this.observer = new ResizeObserver(this.handleResize)
    this.observer.observe(this.$el)
  },

  beforeDestroy () {
    this.observer.unobserve(this.$el)

    this.unbindDragEvents()
  },

  methods: {
    handleResize (entries, observer) {
      this.width = entries[0].contentRect.width
      this.height = entries[0].contentRect.height
      // this.$emit('bounds', {
      //   width: entries[0].contentRect.width,
      //   height: entries[0].contentRect.height,
      // })
    },
  }
}



// WEBPACK FOOTER //
// ./app/javascript/components/mixins/resize-observer.js